var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSmallupwardIconBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.825 12.5584L14.2937 3.04175L4.78125 12.5188L5.51667 13.2563L13.7729 5.02925L13.7937 23.1272H14.8354L14.8146 5.03341L23.0875 13.2959L23.825 12.5584Z",
    fill: "",
    stroke: "",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8604 24.0958C14.8125 24.0479 14.7604 24.0125 14.7063 23.9812C14.4729 23.8458 14.1854 23.8458 13.9521 23.9812C13.8979 24.0125 13.8459 24.05 13.8 24.0958C13.5063 24.3895 13.5063 24.8645 13.8 25.1562C14.0938 25.4479 14.5688 25.45 14.8604 25.1562C15.1521 24.8625 15.1542 24.3875 14.8604 24.0958Z",
    fill: "",
    stroke: "",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallupwardIconBlackRgb);
export default __webpack_public_path__ + "static/media/arrow-smallupward-icon-black-rgb.572f6034e33807f71e88575d059c3b43.svg";
export { ForwardRef as ReactComponent };